import React from 'react';
import { UsersIcon, BookOpenIcon, MapPinIcon, FileTextIcon } from 'lucide-react';
export function SocialProofBar() {
  return <section className="bg-brand-dark text-white py-6 md:py-10 px-4" data-id="element-259">
      <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-260">
        <div className="flex flex-col items-center justify-center" data-id="element-261">
          <BookOpenIcon className="w-10 h-10 text-brand-orange mb-3" data-id="element-262" />
          <span className="text-3xl font-black mb-1" data-id="element-263">+1000</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-264">
            actividades
          </span>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-265">
          <UsersIcon className="w-10 h-10 text-brand-orange mb-3" data-id="element-266" />
          <span className="text-3xl font-black mb-1" data-id="element-267">2 a 10</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-268">
            años
          </span>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-269">
          <FileTextIcon className="w-10 h-10 text-brand-orange mb-3" data-id="element-270" />
          <span className="text-3xl font-black mb-1" data-id="element-271">100%</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-272">
            PDF imprimible
          </span>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-273">
          <MapPinIcon className="w-10 h-10 text-brand-orange mb-3" data-id="element-274" />
          <span className="text-3xl font-black mb-1" data-id="element-275">🇦🇷</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-276">
            Todo el país
          </span>
        </div>
      </div>
    </section>;
}